/**
 * Fanka 变体选择器底部「提示链接」的视频弹窗组件：
 * - 包裹一个 <a href>，按后缀判断 href 是否视频（.mp4/.webm/...）
 * - 是视频：拦截点击，弹出原生 <dialog> 居中小弹窗，<video> 带声音自动播放，播完自动暂停
 * - 非视频：不拦截，交给浏览器默认跳转
 */

// 视频链接判断：按扩展名（可带 query），Liquid/浏览器拿不到 Content-Type，只能靠后缀
const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i;

class FankaFitLink extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a[href]');
    if (!this.link) return;

    this.href = this.link.getAttribute('href');
    // 非视频链接：保持默认跳转行为，不做任何拦截
    if (!VIDEO_EXT.test(this.href)) return;

    this.link.addEventListener('click', this.#openVideo);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.#openVideo);
    this.dialog?.remove();
  }

  // 点击视频链接：阻止跳转，弹窗播放
  #openVideo = (event) => {
    event.preventDefault();
    if (!this.dialog) this.#buildDialog();

    this.video.src = this.href;
    this.dialog.showModal();
    // 在 click 用户手势内调用 play()，浏览器允许带声音自动播放
    this.video.muted = false;
    this.video.play?.().catch(() => {});
  };

  // 懒创建弹窗，整页只建一次
  #buildDialog() {
    this.dialog = document.createElement('dialog');
    this.dialog.className = 'fanka-fit-link__dialog';

    this.video = document.createElement('video');
    this.video.controls = true;
    this.video.playsInline = true; // 移动端内联播放，不强制全屏

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'fanka-fit-link__dialog-close';
    closeBtn.setAttribute('aria-label', '关闭');
    closeBtn.textContent = '×'; // ×
    closeBtn.addEventListener('click', () => this.dialog.close());

    // 点遮罩（dialog 本体而非内部元素）关闭
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    // 播放完成自动暂停（原生播完即暂停，这里显式兜底，且不循环）
    this.video.addEventListener('ended', () => this.video.pause());

    // 关闭时暂停并卸载 src：停声音、省流量
    this.dialog.addEventListener('close', () => {
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
    });

    this.dialog.append(closeBtn, this.video);
    document.body.appendChild(this.dialog);
  }
}

customElements.define('fanka-fit-link', FankaFitLink);
